import CustomScrollbar from '@r1-frontend/ui-react/components/CustomScrollbar';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { Indent, isIndent } from '@r1-frontend/ui-react/experimental/containers/IndentContainer';
import { TListSize } from '@r1-frontend/ui-react/experimental/containers/ListContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

interface IPopupState {
    isOpen: boolean,
    children: React.ReactNode,
    dPadding?: Indent,
    mPadding?: Indent,
    onClose: () => void,
}

const scrollIndent: Indent = 8; // Отступ скрола от контента
const popupIndent = 24; // Отступ попапа от края экрана

/**
 * Базовый попап выровненный по правому краю, с отступом под кастомный скролл
 * Компонент скролла экспортируется отдельно
 * TODO вытащить в ui-react
 */
const BasePopupRightAlign = ({
    isOpen,
    onClose,
    children,
    dPadding = 24,
    mPadding = 16,
}: IPopupState): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);
    const popupHeight = isMobile ? '100vh' : `calc(100vh - ${2 * popupIndent}px)`;
    // Паддинг справа минус отступ от скролла
    const desktopPadding = dPadding - scrollIndent;
    const scrollPaddingDesktop = isIndent(desktopPadding) ? desktopPadding : scrollIndent;
    const mobilePadding = dPadding - scrollIndent;
    const scrollPaddingMobile = isIndent(mobilePadding) ? mobilePadding : scrollIndent;
    const rightIndent = isMobile ? 'auto' : `${popupIndent}px`;

    return (
        <DefaultPopup
            isOpen={isOpen}
            onClose={onClose}
            width={isMobile ? '100%' : '650px'}
            height={popupHeight}
            style={{
                overflowY: 'visible',
                alignSelf: 'stretch',
                margin: isMobile ? '0' : `${popupIndent}px ${rightIndent} ${popupIndent}px auto`,
                maxWidth: 'none',
                maxHeight: 'none',
                borderRadius: isMobile ? '0' : BorderRadius.OuterBlockRadius,
            }}
            customStyles={{
                popup: {},
                closePopup: {
                    default: {
                        top: `${dPadding}px`,
                        right: `${dPadding}px`,
                    },
                    mobile: {
                        top: `${mPadding}px`,
                        right: `${mPadding}px`,
                    },
                },
            }}
        >
            <IndentContainer
                $desktop={[dPadding, scrollPaddingDesktop, dPadding, dPadding]}
                $mobile={[mPadding, scrollPaddingMobile, mPadding, mPadding]}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexWrap: 'nowrap',
                    position: 'relative',
                    height: '100%',
                }}
            >
                {children}
            </IndentContainer>
        </DefaultPopup>
    );
};

interface IProps {
    children: React.ReactNode,
    $desktop?: TListSize,
    $mobile?: TListSize,
    desktopHeaderHeight?: number,
    mobileHeaderHeight?: number,
}

/**
 * Компонент скрола
 */
const TheScrollbar = ({
    children,
}: IProps) => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);

    return <CustomScrollbar
        customStyles={{
            view: {
                paddingRight: isMobile ? '0px' : `${scrollIndent}px`,
                display: 'block',
            },
        }}
    >
        {children}
    </CustomScrollbar>;
};

export {
    BasePopupRightAlign,
    TheScrollbar,
};
